// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aPnqBD5S1ba99j {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  max-width: 224px;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-025, 2px);
  gap: var(--ds-space-050, 4px);
}
.aPnqBD5S1ba99j .l6GVfjSnb2Zd2_ {
  padding: var(--ds-space-025, 2px) var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
}
.aPnqBD5S1ba99j .l6GVfjSnb2Zd2_ .leiTVDsEIibRDJ,
.aPnqBD5S1ba99j .l6GVfjSnb2Zd2_ .iscFjEHQhhQERO {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  margin-bottom: var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
  font-size: 11px;
  line-height: 12px;
  white-space: nowrap;
}
.aPnqBD5S1ba99j .l6GVfjSnb2Zd2_ .NQHlzST3Rubopy {
  display: flex;
  align-items: center;
}
.aPnqBD5S1ba99j .l6GVfjSnb2Zd2_ .iscFjEHQhhQERO {
  margin-top: var(--ds-space-0, 0);
  font-weight: var(--ds-font-weight-regular, 400);
}
.aPnqBD5S1ba99j:focus-within {
  outline: none;
}
.f3hLwlT8jKwZNs {
  height: 14px;
  border-radius: var(--ds-border-radius-200, 6px);
}
.I8PqvJBN2TVD6z {
  height: 24px;
  border-radius: var(--ds-border-radius-200, 8px);
}
.rdBeosgI3H_dyp {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.rdBeosgI3H_dyp .l6GVfjSnb2Zd2_ {
  display: flex;
  flex-direction: column;
}
.rdBeosgI3H_dyp .l6GVfjSnb2Zd2_ .leiTVDsEIibRDJ {
  font-weight: var(--ds-font-weight-bold, 700);
}
.rdBeosgI3H_dyp:hover {
  background-color: var(--ds-background-accent-gray-subtlest-hovered, #dcdfe4);
  text-decoration: none;
}
.Eujlzm347ygomi .l6GVfjSnb2Zd2_ {
  display: flex;
}
.Eujlzm347ygomi .l6GVfjSnb2Zd2_ .NQHlzST3Rubopy p {
  font-weight: var(--ds-font-weight-regular, 400);
}
.wHlvdzV7BjvcgF {
  display: none;
  position: relative;
  bottom: var(--ds-space-050, 4px);
  max-height: 10px;
}
.rYZ8_2t8g4Dt27 {
  display: flex;
  align-items: center;
}
.aPnqBD5S1ba99j:hover .wHlvdzV7BjvcgF {
  display: flex;
}
`, ""]);
// Exports
export var cardFrontBoardChip = `aPnqBD5S1ba99j`;
export var names = `l6GVfjSnb2Zd2_`;
export var boardNameText = `leiTVDsEIibRDJ`;
export var listName = `iscFjEHQhhQERO`;
export var boardName = `NQHlzST3Rubopy`;
export var compact = `f3hLwlT8jKwZNs`;
export var expanded = `I8PqvJBN2TVD6z`;
export var showListName = `rdBeosgI3H_dyp`;
export var free = `Eujlzm347ygomi`;
export var externalLinkIcon = `wHlvdzV7BjvcgF`;
export var boardChipContents = `rYZ8_2t8g4Dt27`;
export default ___CSS_LOADER_EXPORT___;
